import { controls as dataControls } from '@wordpress/data-controls';

const controls = {
    ...dataControls,
}

export default controls;
